import React, { useState, useEffect } from "react";
import valid from "card-validator";
import { CiLock } from 'react-icons/ci';
import { RiArrowDropDownLine } from "react-icons/ri";
import "./CardForm.css";

const formatCardNumber = (value: string) =>
  value.replace(/\D/g, "").slice(0, 16).replace(/(.{4})/g, "$1 ").trim();

const formatExpiry = (value: string) => {
  const cleaned = value.replace(/\D/g, "").slice(0, 4);
  if (cleaned.length < 3) return cleaned;
  return `${cleaned.slice(0, 2)}/${cleaned.slice(2)}`;
};

interface Props {
    cardType: any;
    setCardType: any;
    cardNumber: any;
    setCardNumber: any;
    expiry: any;
    setExpiry: any;
    cvc: any;
    setCvc: any;
    nameOnCard: any;
    setNameOnCard: any;
    useShippingAsBilling: any;
    setUseShippingAsBilling: any;

    country2: any;
    setCountry2: any;
    firstName2: any;
    setFirstName2: any;
    lastName2: any;
    setLastName2: any;
    address2: any;
    setAddress2: any;
    apartment2: any;
    setApartment2: any;
    city2: any;
    setCity2: any;
    state2: any; 
    setState2: any;
    zipCode2: any;
    setZipCode2: any;

    errors: any;
    setErrors: any;
    errorsExpiry: any;
    setErrorsExpiry: any;
    errorsCvc: any;
    setErrorsCvc: any;
    status: any;
    setStatus: any;

    countryError2: any;
    firstNameError2: any;
    lastNameError2: any;
    addressError2: any;
    cityError2: any;
    stateError2: any;
    zipCodeError2: any;
    nameOnCardError: any;

    cardNumberTouched: any;
    setCardNumberTouched: any;
    expiryTouched: any;
    setExpiryTouched: any;
    cvcTouched: any;
    setCvcTouched: any;

    onSubmit: any;
}
type CardInfo = {
  src: string;
  alt: string;
};



const availableCards: CardInfo[] = [
  { src: "/new-img/cards/visa.svg", alt: "VISA" },
  { src: "/new-img/cards/mastercard.svg", alt: "MASTERCARD" },
  { src: "/new-img/cards/amex.svg", alt: "AMEX" },
  { src: "/new-img/cards/discover.svg", alt: "DISCOVER" },
  { src: "/new-img/cards/jcb.svg", alt: "JCB" },
  { src: "/new-img/cards/diners_club.svg", alt: "DINERS" },
  { src: "/new-img/cards/unionpay.svg", alt: "UNIONPAY" },
  { src: "/new-img/cards/elo.svg", alt: "ELO" },
];

const normalizeType = (type: string) =>
  type
    .toUpperCase()
    .replace(/\s|-/g, "")
    .replace("AMERICANEXPRESS", "AMEX")
    .replace("DINERSCLUB", "DINERS");




const CardForm: React.FC<Props> = ({ cardType, setCardType, cardNumber, setCardNumber, expiry, setExpiry, cvc, setCvc, nameOnCard, setNameOnCard, useShippingAsBilling, setUseShippingAsBilling, 
    country2,
    setCountry2,
    firstName2,
    setFirstName2,
    lastName2,
    setLastName2,
    address2,
    setAddress2,
    apartment2,
    setApartment2,
    city2,
    setCity2,
    state2, 
    setState2,
    zipCode2,
    setZipCode2,

    errors,
    setErrors,
    errorsExpiry,
    setErrorsExpiry,
    errorsCvc,
    setErrorsCvc,
    status,
    setStatus,

    nameOnCardError,
    countryError2,
    firstNameError2,
    lastNameError2,
    addressError2,
    cityError2,
    stateError2,
    zipCodeError2,

    cardNumberTouched,
    setCardNumberTouched,
    expiryTouched,
    setExpiryTouched,
    cvcTouched,
    setCvcTouched,

    onSubmit

 }) => {

// const CiLock: IconType
// console.log(CiLock)


  // Card Detection
  const formatCardNumber = (value: string) => {
    return value
      .replace(/\D/g, "")
      .replace(/(.{4})/g, "$1 ")
      .trim();
  };
  const handleCardNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    const formatted = formatCardNumber(input);
    setCardNumber(formatted);

    const numberValidation = valid.number(formatted.replace(/\s/g, ""));
    const detectedType = numberValidation.card?.niceType;

    if (detectedType) {
      const normalized = normalizeType(detectedType);
      const matchedCard = availableCards.find(
        (card) => normalizeType(card.alt) === normalized
      );
      setCardType(matchedCard?.alt ?? "UNKNOWN");
    } else {
      setCardType(null);
    }
  };
  const handleExpiryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatExpiry(e.target.value);
    setExpiry(formatted);
  };

  useEffect(() => {
    if (!cardNumberTouched) return;

    const newErrors: { [key: string]: string } = {};
    const numberValidation = valid.number(cardNumber.replace(/\s/g, ""));
    if (!numberValidation.isValid) newErrors.cardNumber = "Invalid card number";

    setErrors(newErrors);
  }, [cardNumber, cardNumberTouched]);

  useEffect(() => {
    if (!expiryTouched) return;

    const newErrors: { [key: string]: string } = {};
    const expiryValidation = valid.expirationDate(expiry);
    if (!expiryValidation.isValid) newErrors.expiry = "Invalid expiration date";

    setErrorsExpiry(newErrors);
  }, [expiry, expiryTouched]);

  useEffect(() => {
    if (!cvcTouched) return;

    const newErrors: { [key: string]: string } = {};
    if (!/^\d{3,4}$/.test(cvc)) {
      newErrors.cvc = "Security cod must be 3 or 4 digits";
    }

    setErrorsCvc(newErrors);
  }, [cvc, cvcTouched]);



  return (
    <main className="card-form__CardForm">
        <div className={`floating-label-input ${cardNumber ? "filled__paymentForm" : ""} ${errors.cardNumber ? "error__CardForm" : ""}`} style={{ marginBottom: '1.5rem' }}>
          <input
            style={{ marginBottom: '0' }}
            type="text"
            value={cardNumber}
            onChange={(e) => {
              handleCardNumberChange(e);
            }}
            onBlur={() => {
              const newErrors: { [key: string]: string } = {};
              const numberValidation = valid.number(cardNumber.replace(/\s/g, ""));
              if (!numberValidation.isValid) newErrors.cardNumber = "Invalid card number";
              setErrors(newErrors);
              setCardNumberTouched(true);
            }}
            placeholder=" "
          />
          <label>Card number</label>
          {CiLock && (
            <span>
              <CiLock style={{ position: 'absolute', right: '1.7rem', top: '18.5px', fontSize: '1.7rem', color: '#333' }} />
            </span>
          )}
          {errors.cardNumber && cardNumberTouched && <div className="error-text__CardForm">{errors.cardNumber}</div>}
        </div>

          <div className="row__paymentForm" style={{ marginBottom: '1.5rem' }}>
            <div className={`floating-label-input ${expiry ? "filled__paymentForm" : ""} ${errorsExpiry.expiry ? "error__CardForm" : ""}`}>
              <input
                style={{ marginBottom: '0' }}
                type="text"
                value={expiry}
                onChange={handleExpiryChange}
                onBlur={() => {
                  const newErrors: { [key: string]: string } = {};
                  const expiryValidation = valid.expirationDate(expiry);
                  if (!expiryValidation.isValid) newErrors.expiry = "Invalid expiration date";
                  setErrorsExpiry(newErrors);
                  setExpiryTouched(true);
                }}
                placeholder=" "
              />
              <label>Expiration date (MM/YY)</label>
              {errorsExpiry.expiry && expiryTouched && <div className="error-text__CardForm">{errorsExpiry.expiry}</div>}
            </div>

            <div className={`floating-label-input ${cvc ? "filled__paymentForm" : ""} ${errorsCvc.cvc ? "error__CardForm" : ""}`}>
              <input
                style={{ marginBottom: '0' }}
                type="text"
                value={cvc}
                onChange={(e) => setCvc(e.target.value.replace(/\D/g, "").slice(0, 4))}
                onBlur={() => {
                  const newErrors: { [key: string]: string } = {};
                  if (!/^\d{3,4}$/.test(cvc)) newErrors.cvc = "Security code must be 3 or 4 digits";
                  setErrorsCvc(newErrors);
                  setCvcTouched(true);
                }}
                placeholder=" "
              />
              <label>Security code</label>
              {errorsCvc.cvc && cvcTouched && <div className="error-text__CardForm">{errorsCvc.cvc}</div>}
            </div>
          </div>



            <div className={`floating-label-input ${nameOnCard ? 'filled__paymentForm' : ''} ${nameOnCardError ? "error__CardForm" : ""}`}>
              <input
                type="text"
                value={nameOnCard}
                onChange={(e) => setNameOnCard(e.target.value)}
              />
              <label>Name on card</label>
              {nameOnCardError && <div className="error-text__CardForm">{nameOnCardError}</div>}
            </div>

            <div
              style={{
                "--checkbox-size": "var(--checkbox-size-md)",
                "--checkbox-color": "var(--gray-01)",
                "--label-fz": "var(--mantine-font-size-md)",
                "--label-lh": "var(--label-lh-md)",
                marginBottom: "30px",
              } as React.CSSProperties}
              className="m_bf2d988c mantine-Checkbox-root m_5f75b09e mantine-Checkbox-root"
              data-size="md"
              data-label-position="right"
              data-checked={useShippingAsBilling}
            >
              <div className="m_5f6e695e mantine-Checkbox-body aliign_items-center" style={{marginBottom: '25px'}}>
                <div className="m_26062bec mantine-Checkbox-inner" data-label-position="right">
                  <input
                    className="mantine-focus-auto m_26063560 mantine-Checkbox-input"
                    id="mantine-v3tcd6bih"
                    data-path="canReceiveSms"
                    type="checkbox"
                    checked={useShippingAsBilling}
                    onChange={() => setUseShippingAsBilling(!useShippingAsBilling)}
                    style={{
                      "--checkbox-size": "var(--checkbox-size-md)",
                      "--checkbox-color": "var(--gray-01)",
                      "--label-fz": "var(--mantine-font-size-md)",
                      "--label-lh": "var(--label-lh-md)",
                      cursor: "pointer",
                      border: "0.5px solid gray",
                    } as React.CSSProperties}
                  />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    className="m_bf295423 mantine-Checkbox-icon"
                  >
                    <path
                      d="M13.3337 4L6.00033 11.3333L2.66699 8"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div className="m_d3ea56bb mantine-Checkbox-labelWrapper">
                  <label
                    className="tw-font-inter tw-text-gray-02 tw-text-sm m_8ee546b8 mantine-Checkbox-label"
                    htmlFor="mantine-v3tcd6bih"
                  >
                    Use shipping address as billing address.
                  </label>
                </div>
              </div>

              {

                !useShippingAsBilling
                ?
                <div>
                    <div className="row--spacebetween__paymentForm" style={{marginBottom: '5px', fontSize: '1.2rem'}}>
                      <label style={{margin: '0'}}>Billing address</label>
                    </div>

                    <div style={{marginBottom: '30px'}}>

                        <div className={`floating-label-input ${country2 ? 'filled__paymentForm' : ''} ${countryError2 ? "error__CardForm" : ""}`} style={{ marginBottom: '1.5rem' }}>
                          <select style={{  }} onChange={(e) => setCountry2(e.target.value)} value={country2}>
                              <option value=""></option>
                              <option value="US">United States</option>
                              <option value="AR">Argentina</option>
                              <option value="AU">Australia</option>
                              <option value="BR">Brazil</option>
                              <option value="CA">Canada</option>
                              <option value="CN">China</option>
                              <option value="FR">France</option>
                              <option value="DE">Germany</option>
                              <option value="IN">India</option>
                              <option value="ID">Indonesia</option>
                              <option value="IT">Italy</option>
                              <option value="JP">Japan</option>
                              <option value="KR">South Korea</option>
                              <option value="MX">Mexico</option>
                              <option value="RU">Russia</option>
                              <option value="SA">Saudi Arabia</option>
                              <option value="ZA">South Africa</option>
                              <option value="TR">Turkey</option>
                              <option value="GB">United Kingdom</option>
                              <option value="EU">European Union</option>
                          </select>
                          <label>Country/Region</label>
                          {countryError2 && <div className="error-text__CardForm">{countryError2}</div>}
                          <RiArrowDropDownLine style={{position: 'absolute', right: '0rem', top: '10px', fontSize: '3rem', color: 'gray'}} />
                        </div>

                        <div className="row__paymentForm" style={{ marginBottom: '1.5rem' }}>
                          <div className={`floating-label-input ${firstName2 ? 'filled__paymentForm' : ''} ${firstNameError2 ? "error__CardForm" : ""}`}>
                            <input
                              type="text"
                              value={firstName2}
                              onChange={(e) => setFirstName2(e.target.value)}
                            />
                            <label>First Name</label>
                            {firstNameError2 && <div className="error-text__CardForm">{firstNameError2}</div>}
                          </div>

                          <div className={`floating-label-input ${lastName2 ? 'filled__paymentForm' : ''} ${lastNameError2 ? "error__CardForm" : ""}`}>
                            <input
                              type="text"
                              value={lastName2}
                              onChange={(e) => setLastName2(e.target.value)}
                            />
                            <label>Last Name</label>
                            {lastNameError2 && <div className="error-text__CardForm">{lastNameError2}</div>}
                          </div>
                        </div>

                        <div className={`floating-label-input ${address2 ? 'filled__paymentForm' : ''} ${addressError2 ? "error__CardForm" : ""}`} style={{ marginBottom: '1.5rem' }}>
                          <input
                            type="type"
                            value={address2}
                            onChange={(e) => setAddress2(e.target.value)}
                          />
                          <label>Address</label>
                          {addressError2 && <div className="error-text__CardForm">{addressError2}</div>}
                        </div>
                        <div className={`floating-label-input ${apartment2 ? 'filled__paymentForm' : ''}`} style={{ marginBottom: '1.5rem' }}>
                          <input
                            type="type"
                            value={apartment2}
                            onChange={(e) => setApartment2(e.target.value)}
                          />
                          <label>Apartment, suite, etc. (optional)</label>
                        </div>
                        <div className="row__paymentForm" style={{ marginBottom: '1.5rem' }}>
                            <div className={`floating-label-input ${city2 ? 'filled__paymentForm' : ''} ${cityError2 ? "error__CardForm" : ""}`}>
                              <input
                                type="text"
                                value={city2}
                                onChange={(e) => setCity2(e.target.value)}
                              />
                              <label>City</label>
                              {cityError2 && <div className="error-text__CardForm">{cityError2}</div>}
                            </div>

                            <div id="lone-select-field__paymentForm" className={`floating-label-input ${state2 ? 'filled__paymentForm' : ''} ${stateError2 ? "error__CardForm" : ""}`}>
                              <select  style={{ }} onChange={(e) => setState2(e.target.value)} value={state2}>
                                  <option value=""></option>
                                  <option value="AL">Alabama</option>
                                  <option value="AK">Alaska</option>
                                  <option value="AZ">Arizona</option>
                                  <option value="AR">Arkansas</option>
                                  <option value="CA">California</option>
                                  <option value="CO">Colorado</option>
                                  <option value="CT">Connecticut</option>
                                  <option value="DE">Delaware</option>
                                  <option value="FL">Florida</option>
                                  <option value="GA">Georgia</option>
                                  <option value="HI">Hawaii</option>
                                  <option value="ID">Idaho</option>
                                  <option value="IL">Illinois</option>
                                  <option value="IN">Indiana</option>
                                  <option value="IA">Iowa</option>
                                  <option value="KS">Kansas</option>
                                  <option value="KY">Kentucky</option>
                                  <option value="LA">Louisiana</option>
                                  <option value="ME">Maine</option>
                                  <option value="MD">Maryland</option>
                                  <option value="MA">Massachusetts</option>
                                  <option value="MI">Michigan</option>
                                  <option value="MN">Minnesota</option>
                                  <option value="MS">Mississippi</option>
                                  <option value="MO">Missouri</option>
                                  <option value="MT">Montana</option>
                                  <option value="NE">Nebraska</option>
                                  <option value="NV">Nevada</option>
                                  <option value="NH">New Hampshire</option>
                                  <option value="NJ">New Jersey</option>
                                  <option value="NM">New Mexico</option>
                                  <option value="NY">New York</option>
                                  <option value="NC">North Carolina</option>
                                  <option value="ND">North Dakota</option>
                                  <option value="OH">Ohio</option>
                                  <option value="OK">Oklahoma</option>
                                  <option value="OR">Oregon</option>
                                  <option value="PA">Pennsylvania</option>
                                  <option value="RI">Rhode Island</option>
                                  <option value="SC">South Carolina</option>
                                  <option value="SD">South Dakota</option>
                                  <option value="TN">Tennessee</option>
                                  <option value="TX">Texas</option>
                                  <option value="UT">Utah</option>
                                  <option value="VT">Vermont</option>
                                  <option value="VA">Virginia</option>
                                  <option value="WA">Washington</option>
                                  <option value="WV">West Virginia</option>
                                  <option value="WI">Wisconsin</option>
                                  <option value="WY">Wyoming</option>
                              </select>
                              <label>State</label>
                              <RiArrowDropDownLine style={{position: 'absolute', right: '0rem', top: '10px', fontSize: '3rem', color: 'gray'}} />
                              {stateError2 && <div className="error-text__CardForm">{stateError2}</div>}
                            </div>

                            <div className={`floating-label-input ${zipCode2 ? 'filled__paymentForm' : ''} ${zipCodeError2 ? "error__CardForm" : ""}`}>
                              <input
                                type="text"
                                value={zipCode2}
                                onChange={(e) => setZipCode2(e.target.value)}
                              />
                              <label>Zip code</label>
                              {zipCodeError2 && <div className="error-text__CardForm">{zipCodeError2}</div>}
                            </div>
                        </div>
                    </div>
                </div>
                :
                null

              }
              


              </div>

      

            <button type="submit" onClick={onSubmit}>Pay Now</button>
    </main>
  );
};

export default CardForm;
